// Unpublished Work © 2023-2026 Deere & Company.

import {getStatusItems} from 'Utils/parts-utils';
import {IconAdd, IconNewWindow} from '@deere/icons';
import React from 'react';
import {MultiSelect} from '@deere/isg.component-library';
import PropTypes from 'Utils/prop-type-utils';
import {useNavBarActions} from 'Ui/react-hooks/use-navbar-actions';
import {PARTS_CATALOG_URL, SHOP_URL} from 'Ui/components/secondary-navbar/utils/dropdown-navbar-helper';
import {MODIFY_FINANCIAL_DATA} from 'Common/constants/business-activities';
import {isShopDeereUrlEnabled} from 'Src/ui-core/pages/onequip/parts/inventory';

function OrdersFilterComponent(props) {
    const {
        translations,
        statusFilter,
        setStatusFilter,
        openAddPurchaseOrderDialog,
        inventories,
        loading,
        callGetPurchaseOrders,
        membership
    } = props;

    const onAddPurchaseOrderClick = () => openAddPurchaseOrderDialog({
        inventories,
        translations,
        onClose: callGetPurchaseOrders,
        membership
    });

    const navBarActions = [
        {
            disabled: loading,
            onClick: onAddPurchaseOrderClick,
            title: 'ONLINK_ADD_PURCHASE_ORDER',
            Icon: <IconAdd/>,
            variant: 'primary',
            requiredMyJdPermissions: MODIFY_FINANCIAL_DATA
        },
        {
            onClick: () => window.open(isShopDeereUrlEnabled(membership) ? SHOP_URL : PARTS_CATALOG_URL, '_blank'),
            title: 'SHOP_FOR_PARTS',
            Icon: <IconNewWindow/>
        }
    ];

    useNavBarActions(navBarActions);

    return (
        <div className={'extra-table-options'}>
            <div className={'status-filter'}>
                <MultiSelect
                    disableSorting={true}
                    hideFilter={false}
                    items={getStatusItems(translations)}
                    labels={{
                        allSelect: translations.ONLINK_ALL_STATUSES,
                        multiSelect: translations.ONLINK_STATUSES_SELECTED,
                        placeholder: translations.ONLINK_SELECT_STATUS,
                        selectAllItems: translations.ONLINK_ALL_STATUSES
                    }}
                    name={'filterStatus'}
                    noSearch={true}
                    onChange={(ids) => setStatusFilter(ids)}
                    selectedIds={statusFilter}
                    single={false}
                    tabIndex={0}
                />
            </div>
        </div>
    );
}

OrdersFilterComponent.propTypes = {
    callGetPurchaseOrders: PropTypes.func,
    inventories: PropTypes.arrayOf(PropTypes.object),
    loading: PropTypes.bool,
    membership: PropTypes.membership,
    openAddPurchaseOrderDialog: PropTypes.func,
    setStatusFilter: PropTypes.func,
    statusFilter: PropTypes.arrayOf(PropTypes.string),
    translations: PropTypes.translations
};

export default OrdersFilterComponent;
